<div class="dialog-header">
  <h2>Inner Transfer</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Search</label>
    <input type="text" [(ngModel)]="form.search" (ngModelChange)="onSearch()" />
  </div>

  <div class="form-group">
    <label>Customer Inner Transfer To</label>
    <input type="text" [(ngModel)]="form.customerInnerTransferTo" />
  </div>

  <div class="form-group">
    <label>TransferCost</label>
    <input type="number" [(ngModel)]="form.transferCost" />
  </div>

  <div class="form-group">
    <label>Cash Paid</label>
    <input type="number" [(ngModel)]="form.cashPaid" />
  </div>

  <div class="form-group">
    <label>Visa Paid</label>
    <input type="number" [(ngModel)]="form.visaPaid" />
  </div>

  <div class="form-group">
    <label>Contactless Cash Paid</label>
    <input type="number" [(ngModel)]="form.contactlessCashPaid" />
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
